<div class="container-fluid mt-3 g-0 px-3">

    <div class="row">
        @for (zone of Model?.ZoneList; track zone; let i = $index) {
        <div class="col-12 col-md-4 col-xl-3 p-1 ">
            <div class="h-100 m-3">
                <div class="row left-card-border border rounded-1 background-light " style="border-left-color: cornflowerblue !important">
                    <div class="col mx-2 p-1">
                        <div class="row">
                            <span class="my-2 col text-center"> {{zone.ZoneSalle}} </span>
                        </div>

                        @if (zone.PrelevementQualifSalle) {
                        <div class="row">
                            <span class="my-2 col text-center"> {{zone.PrelevementQualifSalle.Code}} - {{zone.PrelevementQualifSalle.Prelevement.OgiCode}}</span>
                        </div>

                        <div class="row justify-content-center">
                            <div class="col">
                                <button appPreventDoubleClick mat-raised-button color="primary" class="w-100 text-center mx-1 mat-elevation-z0" (throttledClick)="openDocumentDialog(zone.PrelevementQualifSalle.Code, EDocumentType.Plan)">
                                    <mat-icon class="material-symbols-outlined">
                                        upload_file
                                    </mat-icon>
                                    Envoyer le plan
                                </button>
                            </div>

                            <div class="col">
                                <button appPreventDoubleClick mat-raised-button color="primary" class="w-100 text-center mx-1 mat-elevation-z0" (throttledClick)="openDocumentDialog(zone.PrelevementQualifSalle.Code, EDocumentType.OverrideReport)">
                                    <mat-icon class="material-symbols-outlined">
                                        upload_file
                                    </mat-icon>
                                    Ecraser le rapport
                                </button>
                            </div>
                        </div>
                        <div class="row justify-content-center my-2">
                            <div class="col">
                                <button appPreventDoubleClick mat-raised-button color="accent" class="w-100 text-center mx-1 mat-elevation-z0" (throttledClick)="generateReportDocument(zone.PrelevementQualifSalle.Code)">
                                    <mat-icon class="material-symbols-outlined">
                                        picture_as_pdf
                                    </mat-icon>
                                    Générer le rapport
                                </button>
                            </div>
                        </div>
                        <div class="row justify-content-center align-items-center text-center">
                            <div class="col">
                                Mesure Terrain
                            </div>
                            <div class="col-auto">
                                <button class="h-100" mat-icon-button matTooltip="Mesure Terrain" (click)="getMesureTerrainForQualifSalleDocument(zone.PrelevementQualifSalle.Code)">
                                    <mat-icon class="material-symbols-outlined">download</mat-icon>
                                </button>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="row justify-content-center align-items-center text-center">
                            <div class="col">
                                Plan
                            </div>
                            <div class="col-auto">
                                <button class="h-100" mat-icon-button matTooltip="Plan" (click)="getPlanForQualifSalleDocument(zone.PrelevementQualifSalle.Code)">
                                    <mat-icon class="material-symbols-outlined">download</mat-icon>
                                </button>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="row justify-content-center align-items-center text-center">
                            <div class="col">
                                Rapport (docx)
                            </div>
                            <div class="col-auto">
                                <button class="h-100" mat-icon-button matTooltip="Mesure Terrain" (click)="getReportRawVersionDocument(zone.PrelevementQualifSalle.Code)">
                                    <mat-icon class="material-symbols-outlined">download</mat-icon>
                                </button>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="row justify-content-center align-items-center text-center">
                            <div class="col">
                                Rapport (pdf)
                            </div>
                            <div class="col-auto">
                                <button class="h-100" mat-icon-button matTooltip="Mesure Terrain" (click)="getReportDocument(zone.PrelevementQualifSalle.Code)">
                                    <mat-icon class="material-symbols-outlined">download</mat-icon>
                                </button>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        }
    </div>

</div>